import type React from "react";

import { H1, H2, H3, H4, H5, H6 } from "simplydo/react/ui/header";
import { Icon, type LucideIconData } from "simplydo/react/ui/icon";

const headings = { h1: H1, h2: H2, h3: H3, h4: H4, h5: H5, h6: H6 };

export type IconHeaderProps = {
  as?: keyof typeof headings;
  icon?: LucideIconData;
  header: string;
  content: string | React.ReactNode;
  wrapped?: boolean;
};

export const IconHeader: React.FC<IconHeaderProps> = ({
  as,
  icon,
  header,
  content,
  wrapped,
}: IconHeaderProps) => {
  const Heading = headings[as ?? "h3"];

  if (wrapped) {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: 5,
            marginTop: 5,
          }}
        >
          {icon ? (
            <Icon
              icon={icon}
              style={{
                fontSize: 40,
                height: "0.8em",
                color: "rgb(75, 92, 107)",
              }}
            />
          ) : null}
          <Heading style={{ margin: "0 0 5px 0" }}>{header}</Heading>
        </div>
        <div>{content}</div>
      </div>
    );
  }
  return (
    <div style={{ display: "flex", flex: "auto" }}>
      {icon ? (
        <div style={{ textAlign: "center" }}>
          <Icon
            icon={icon}
            style={{ fontSize: 40, color: "rgb(75, 92, 107)" }}
          />
        </div>
      ) : null}
      <div
        style={{ display: "flex", flexDirection: "column", paddingLeft: 10 }}
      >
        <Heading style={{ marginBottom: 5 }}>{header}</Heading>
        <div>{content}</div>
      </div>

      <div style={{ clear: "both" }} />
    </div>
  );
};
